import { $, html, View } from 'rune-ts';
import klass from './ButtonShow.module.scss';
import { ShowHiddenIcon, ShowIcon } from '../Icon';

export interface ButtonShowProps {
  type?: 'submit' | 'button' | 'reset';
  show?: boolean;
  tag?: 'button' | 'span';
}

class Button extends View<ButtonShowProps> {
  override template() {
    const { type, tag } = this.data;

    if (tag === 'span') {
      return html` <span class="${klass.button}"></span> `;
    }

    return html` <button class="${klass.button}" type="${type ?? 'button'}"></button> `;
  }
}

export class ButtonShow extends View<ButtonShowProps> {
  button: Button;

  constructor(data) {
    super(data);
    this.button = new Button(this.data);
  }

  override template() {
    return html`
      <label class="${klass.button_show}">
        ${this.button}
        <span class="show ${klass.show}">${this.data.show ? ShowHiddenIcon : ShowIcon}</span>
      </label>
    `;
  }

  isShow() {
    return this.data.show;
  }

  toggleShow() {
    this.data.show = !this.data.show;
  }

  override redraw(): this {
    const show$ = $(this.element()).find('.show');

    if (show$) {
      show$.setInnerHtml(this.data.show ? ShowHiddenIcon.make(this) : ShowIcon.make(this));
    }

    return this;
  }
}
